export const masks: Record<string, string | undefined> = {
  US: '(111) - 111-1111'
};
